import Layout from '@/views/layout/index'
import permCode from '@/config/permCode'

export default [
  {
    path: '/lark',
    component: Layout,
    hidden: true,
    meta: {},
    children: [{
      path: 'index',
      meta: {
        permission: permCode.LARK_ORDER_LIST
      },
      component: () => import('@/views/bi-lark/index')
    }, {
      path: 'order',
      meta: {
        permission: permCode.LARK_ORDER_LIST
      },
      component: () => import('@/views/bi-lark/order/index')
    }, {
      path: 'adzone',
      meta: {
        permission: permCode.LARK_ADZONE_LIST
      },
      component: () => import('@/views/bi-lark/adzone/index')
    }]
  }
]
